import { render, staticRenderFns } from "./ViewerCard.vue?vue&type=template&id=f665b820&scoped=true&"
import script from "./ViewerCard.vue?vue&type=script&lang=js&"
export * from "./ViewerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f665b820",
  null
  
)

export default component.exports